export default (
  state,
  { payload: { showSuccessBanner, confirmationType } }
) => ({
  ...state,
  showSuccessBanner,
  confirmationType
});
